export default __webpack_public_path__ + "static/Festool-4d831bd31f65d92293fac997e97325e5.png";